import Link from '@/src/components/ui/atoms/Link/Link';
import { JAM_EVENT_DETAILS_ROUTES } from '@/src/routes';
import { useJamEventDetails } from '@/src/store/jam-event-details.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, ColumnLayout, Container, Icon, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './JamCommonHeader.module.scss';

export interface JamCommonHeaderProps {
  participants: number;
  teams: number;
  facilitators: number;
}

const JamCommonHeader: React.FC<JamCommonHeaderProps> = ({ participants, teams, facilitators }) => {
  const { t } = useTranslation();
  const { eventSlug } = useJamEventDetails();

  return (
    <Container variant="default" className="dark-bg">
      <ColumnLayout columns={4} variant="text-grid">
        <SpaceBetween size="xxxs" direction="vertical">
          <Box>{t(i18nKeys.facilitator.participants.header.teams)}</Box>
          <span className={styles.infoValue} data-testid="jam-teams-count">
            {teams}
          </span>
        </SpaceBetween>
        <SpaceBetween size="xxxs" direction="vertical">
          <Box>{t(i18nKeys.facilitator.participants.header.participants)}</Box>
          <span className={styles.infoValue} data-testid="jam-participants-count">
            {participants}
          </span>
        </SpaceBetween>
        <SpaceBetween size="xxxs" direction="vertical">
          <Box>{t(i18nKeys.facilitator.participants.header.facilitators)}</Box>
          <span className={styles.infoValue} data-testid="jam-facilitators-count">
            {facilitators}
          </span>
        </SpaceBetween>
        <SpaceBetween size="xxxs" direction="vertical">
          <Box>{t(i18nKeys.facilitator.participants.header.currentRank)}</Box>
          <SpaceBetween size="s" direction="horizontal">
            <Box margin={{ top: 's' }}>
              <Link href={JAM_EVENT_DETAILS_ROUTES.LeaderBoard.resolve(eventSlug)} variant="info">
                {t(i18nKeys.jamTeam.actions.leaderboard)} <Icon name="angle-right" size="inherit" />
              </Link>
            </Box>
          </SpaceBetween>
        </SpaceBetween>
      </ColumnLayout>
    </Container>
  );
};

export default JamCommonHeader;
